export default __webpack_public_path__ + "static/media/dripicons-v2.7f392f1e.eot";